import {
  ROLE_PROOF_READER,
  ROLE_SYSTEM_ADMIN,
  ROLE_PROJECT_MNG,
  ROLE_QA_EXPERT,
  ROLE_LSP,
} from '@/utils/const.js';

export default [
  {
    path: '/project-groups/:view?/filters/projects/',
    name: 'project_groups',
    component: () => import('@/views/project_groups/index.vue'),
    meta: {
      baseRoute: 'project-groups',
      title: 'Projects list',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_PROOF_READER,
          ROLE_SYSTEM_ADMIN,
          ROLE_PROJECT_MNG,
          ROLE_QA_EXPERT,
          ROLE_LSP,
        ],
      },
    },
  },
  {
    path: '/project-groups/detail/:id',
    name: 'project_groups_detail',
    component: () => import('@/views/project_groups/project_groups_detail/index.vue'),
    meta: {
      baseRoute: '/project-groups/',
      title: 'Projects detail',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_PROOF_READER,
          ROLE_SYSTEM_ADMIN,
          ROLE_PROJECT_MNG,
          ROLE_QA_EXPERT,
          ROLE_LSP,
        ],
      },
    },
  },
];
